import { HttpErrorResponse } from '@angular/common/http';

export const GENERIC_USER_ERROR = 'Something went wrong. Please try again.';
export const COPY_CONFLICT_MESSAGE = 'Target dates already have allocations.';
export const PAST_DATE_MESSAGE = 'A new allocation cannot be dated before today.';

export type UserFacingErrorKind = 'assign' | 'replace' | 'copy' | 'generic';

export function userFacingApiError(error: unknown, kind: UserFacingErrorKind = 'generic'): string {
  if (error instanceof HttpErrorResponse && error.status >= 400 && error.status < 500) {
    const message = responseMessage(error);
    if (message) {
      return message;
    }
    if (error.status === 409 && kind === 'copy') {
      return COPY_CONFLICT_MESSAGE;
    }
    if (error.status === 422 && (kind === 'assign' || kind === 'replace')) {
      return PAST_DATE_MESSAGE;
    }
  }
  return GENERIC_USER_ERROR;
}

function responseMessage(error: HttpErrorResponse): string | null {
  let body = error.error;
  if (typeof body === 'string') {
    const trimmed = body.trim();
    if (!trimmed) {
      return null;
    }
    // Endpoints requested with responseType 'text' deliver a JSON error body as a raw string.
    try {
      body = JSON.parse(trimmed);
    } catch {
      return trimmed;
    }
    if (typeof body !== 'object' || body === null) {
      return trimmed;
    }
  }
  if (body && typeof body === 'object' && 'message' in body) {
    const message = (body as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message.trim();
    }
  }
  return null;
}
